export enum AuditTrailTableHeaderSearchParameter {
    Entity = 1,
    EventType = 2,
    LogDateTime = 3,
    ModifiedBy = 4,
  }